import { render, staticRenderFns } from "./PanelBlueLabelInvoice.vue?vue&type=template&id=637b2bde&scoped=true&"
import script from "./PanelBlueLabelInvoice.vue?vue&type=script&lang=js&"
export * from "./PanelBlueLabelInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PanelBlueLabelInvoice.vue?vue&type=style&index=0&id=637b2bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b2bde",
  null
  
)

export default component.exports